import React, { Component } from 'react';
import moment from 'moment';

import './index.scss';

const timeFormat = 'HH:mm:ss';

class SecurityMessaging extends Component {
	render() {
		const { list } = this.props;
		return list && list.length > 0 ? (
			<div className="wrapper">
				<div className="inner">
					{list.map(({ createdAt, message }) => (
						<p key={createdAt.toString()}>
							<b>
								[{moment(createdAt).format(timeFormat)}
								{!moment(createdAt).isSame(moment(), 'day') &&
									' - Yesterday'}
								]:
							</b>{' '}
							{message}
						</p>
					))}
				</div>
			</div>
		) : null;
	}
}

export default SecurityMessaging;



// WEBPACK FOOTER //
// ./src/pages/live-view/components/security-messaging/index.js